// 店舗サービス管理: 店舗型定義

/** 除外対象の店舗ID（中央倉庫: 管理用店舗のため通常の選択対象から除外） */
export const EXCLUDED_SELLER_ID = '0a98d3dc-471a-5057-991f-2b52ccc0d92a';

/**
 * 店舗データ（miseスキーマ用）
 */
export interface MiseSeller {
  id: string;
  name: string;
}

/**
 * 店舗階層ノード（snapshot_hot.sellers に所属する店舗グループを付与したもの）
 */
export interface MiseSellerNode extends MiseSeller {
  /** 店舗が直接ぶら下がる店舗グループ（ツリー未所属なら null） */
  parent_id: string | null;
  /** 同じ店舗グループ内での並び順（ツリー未所属なら null） */
  sort_order: number | null;
}

/**
 * 集計前の店舗一覧更新リクエスト
 */
export interface UpdateSellersNextRequest {
  seller_ids: string[];
}

/**
 * 店舗グループデータ（miseスキーマ用）
 */
export interface MiseSellerGroup {
  id: string;
  name: string | null;
}

/**
 * 店舗グループ階層ノード（snapshot_hot.seller_group_warehouse_trees から構築）
 */
export interface MiseSellerGroupNode {
  id: string;
  name: string | null;
  parent_id: string | null;
  level: number;
  sort_order: number;
}

/**
 * 店舗-店舗グループマッピング
 */
export interface MiseSellerSellerGroupMap {
  seller_id: string;
  seller_group_id: string;
}

/**
 * 集計前の店舗グループ一覧更新リクエスト
 */
export interface UpdateSellerGroupsNextRequest {
  seller_group_ids: string[];
}

/**
 * 集計前の店舗-店舗グループマッピング更新リクエスト
 */
export interface UpdateSellerSellerGroupMapNextRequest {
  mappings: MiseSellerSellerGroupMap[];
}
